import { j as t } from "./react-944c88e2.js";
import { Icon as e } from "@chakra-ui/icons";
const s = (o) => /* @__PURE__ */ t.jsxs(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "81px",
    height: "80px",
    viewBox: "0 0 81 80",
    fill: "none",
    ...o,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M75.125 6.62524C75.375 6.50024 74.625 6.50024 74.625 6.50024C74.125 6.50024 73.625 6.62524 73.125 6.75024C71.625 7.00024 70.125 7.25024 68.75 7.50024C65 8.12524 61.125 8.75024 57.25 9.37524C48.625 10.7502 40.125 12.6252 31.625 14.6252C28 15.5002 23.5 15.8752 20.25 17.6252C19.625 18.0002 21 18.5002 21.25 18.6252C23 19.3752 24.875 20.0002 26.625 20.8752C29.125 22.2502 31.625 24.0002 33.875 25.6252C34.25 25.8752 35.625 27.5002 36.125 27.5002",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M75.1252 6.75049C75.1252 6.75049 74.7502 8.62549 74.3752 9.75049C71.7502 18.2505 68.3752 26.2505 67.1252 35.1255C65.7502 44.6255 65.7502 43.7505 65.7502 43.6255",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M66.0002 43.5002C66.1252 43.5002 65.8752 43.5002 65.7502 43.5002C59.8752 40.0002 54.1252 36.2502 48.0002 33.3752C46.6252 32.7502 45.1252 32.2502 43.8752 31.5002",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M43.8757 31.5001C43.8757 31.6251 44.2507 31.2501 44.2507 31.2501C44.5007 31.0001 44.6257 30.7501 44.8757 30.5001C47.3757 27.7501 50.3757 25.7501 53.2507 23.5001C58.0007 19.7501 63.1257 16.2501 67.8757 12.5001C69.5007 11.2501 71.0007 10.0001 72.6257 8.75009C73.2507 8.25009 75.0007 6.87509 74.8757 6.75009C74.7507 6.62509 74.3757 6.87509 74.2507 6.87509C71.1257 8.12509 68.0007 9.50009 65.1257 11.1251C60.1257 13.8751 55.0007 16.7501 49.8757 19.5001C47.2507 21.0001 44.5007 22.2501 42.0007 23.8751C40.2507 24.8751 37.0007 26.3751 35.6257 27.7501",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M35.7502 27.8748C35.7502 27.8748 35.7502 28.7498 35.7502 28.8748C35.7502 30.1248 35.8752 31.2498 35.8752 32.4998C36.0002 35.9998 36.6252 39.3748 36.7502 42.8748C36.7502 44.2498 36.7502 45.6248 37.0002 46.9998C37.0002 46.9998 37.1252 48.2498 37.3752 48.1248C37.7502 47.9998 37.7502 46.8748 37.8752 46.6248C38.2502 45.2498 38.6252 43.8748 39.1252 42.4998C39.6252 41.1248 40.2502 39.6248 40.7502 38.2498C41.3752 36.6248 42.1252 35.1248 42.8752 33.4998C43.2502 32.7498 43.6252 31.7498 44.2502 31.1248",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M37.563 48.3755C37.563 48.0005 38.188 47.6255 38.438 47.3755C39.188 46.5005 40.0468 45.9068 40.7968 45.0318C43.1718 42.5318 46.063 40.3755 48.563 38.0005C49.438 37.1255 50.313 36.6255 50.938 35.5005",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t.jsx("path", { d: "M45.5 32.5L49.875 36.25", stroke: "black", "stroke-width": "2.45" }),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M26.3752 35.5005C17.0002 37.2505 6.37524 47.3755 10.3752 57.3755C10.8752 58.5005 11.5002 59.6255 12.3752 60.5005C18.1252 66.0005 26.1252 59.1255 27.8752 53.2505C28.0002 52.6255 28.1252 52.1255 28.0002 51.5005C27.7502 50.3755 26.5002 49.5005 25.2502 49.5005C24.0002 49.5005 22.8752 50.0005 21.8752 50.6255C14.6252 55.1255 10.2502 69.5005 19.2502 74.5005",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);
export {
  s as S
};
